// GENERATE BY ./scripts/generate.ts
// DON NOT EDIT IT MANUALLY
import * as React from 'react';
import DrrpDacmyapplicantIconOutlinedSvg from "@fishx/icons-svg/es/asn/DrrpDacmyapplicantIconOutlined";
import FishxIcon from '../components/FishxIcon';

var DrrpDacmyapplicantIconOutlined = function DrrpDacmyapplicantIconOutlined(props, ref) {
  return React.createElement(FishxIcon, Object.assign({}, props, {
    ref: ref,
    icon: DrrpDacmyapplicantIconOutlinedSvg
  }));
};

DrrpDacmyapplicantIconOutlined.displayName = 'DrrpDacmyapplicantIconOutlined';
export default React.forwardRef(DrrpDacmyapplicantIconOutlined);


//////////////////
// WEBPACK FOOTER
// ./node_modules/@fishx/icons/es/icons/DrrpDacmyapplicantIconOutlined.js
// module id = 2514
// module chunks = 0